// Factory for image-file-based tile renderers (PNG/SVG assets served from public/).
// Produces a `renderTile` with the same contract as svgRenderer.jsx, so any tile
// library that ships per-tile images can be dropped in with just a code->file map.

export const HONOR_NAMES = {
  '1z': 'Ton', // east
  '2z': 'Nan', // south
  '3z': 'Shaa', // west
  '4z': 'Pei', // north
  '5z': 'Haku', // white dragon
  '6z': 'Hatsu', // green dragon
  '7z': 'Chun', // red dragon
}

const SUIT_NAMES = { m: 'Man', p: 'Pin', s: 'Sou' }

// Shared naming scheme used by FluffyStuff and the riichi-hand-rs MartinPersson set:
// Man1..Man9, Man5-Dora (red five), Pin*, Sou*, Ton/Nan/Shaa/Pei, Haku/Hatsu/Chun, Back.
export function standardTileName(code) {
  if (code === 'xx') return 'Back'
  if (code in HONOR_NAMES) return HONOR_NAMES[code]
  const n = code[0]
  const suit = SUIT_NAMES[code[1]]
  if (!suit) return 'Blank'
  return n === '0' ? `${suit}5-Dora` : `${suit}${n}`
}

export function createImageRenderer({ basePath, fileFor, filesFor, aspect, ext }) {
  // filesFor(code) may return an array of layer file names (stacked bottom -> top);
  // otherwise the single fileFor(code) layer is used.
  const layers = (code) => (filesFor ? filesFor(code) : [fileFor(code)])
  const base = '/' + basePath.replace(/^\//, '')

  return function renderTile({ code, width = 34, highlight = false, rotated = false, highlightColor = '#e2a93b' }) {
    const h = Math.round(width * aspect)
    const outlineW = Math.max(2, Math.round(width * 0.09))

    const frameStyle = {
      display: 'block',
      position: 'relative',
      width: width + 'px',
      height: h + 'px',
    }
    if (highlight) {
      frameStyle.outline = outlineW + 'px solid ' + highlightColor
      frameStyle.outlineOffset = '1px'
      frameStyle.borderRadius = '3px'
    }
    if (rotated) {
      frameStyle.transform = 'rotate(90deg)'
    }

    const wrapStyle = {
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: (rotated ? h : width) + 'px',
      height: h + 'px',
    }

    return (
      <span style={wrapStyle}>
        <span style={frameStyle}>
          {layers(code).map((file, k) => (
            <img
              key={k}
              src={`${base}/${file}.${ext}`}
              alt={k === layers(code).length - 1 ? code : ''}
              draggable={false}
              style={{ position: 'absolute', inset: 0, width: '100%', height: '100%' }}
            />
          ))}
        </span>
      </span>
    )
  }
}
